import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Font, Page, Text, View, Document } from '@react-pdf/renderer';
import { pdfStyles } from './styles';
import tableData from "./tableData";

import FirstTable from './tables/firstTable';
import SecondTable from './tables/secondTable';
import ThirdTable from './tables/thirdTable';
import FourthTable from './tables/fourthTable';
import TableRenderer from './tables/fifthTable';
import { BACKEND_URL_PREFIX } from '../../../utils/const';

const IndividualWorkPlanPrintPdf = ({ layoutData = [], user = [], photo = [], portfolio = [], group = [], gradebook = [], disciplineList = [], semestrName = [], uppercaseGrades = [] }) => {

    const [countOfPage, setCountOfPage] = useState(0)
    const resolveBigTableData = data => {
        const stack = [];
        const withEmptyPeriod = Object.values(data)?.map((period) => Object.values(period)).map((two, i) => two !== null && two.length === 2 ? two : i % 2 !== 0 ? [[], ...two] : [...two, []])
        withEmptyPeriod.map(el => el.forEach(lol => stack.push(lol)))
        // Object.keys(data)
        //     .map(period => Object.keys(data[period])
        //         .map(el => data[period][el]))
        //     .forEach(el => {
        //         stack.push(el[0]);
        //         if (el.length === 2) {
        //             stack.push(el[1])
        //         } else {
        //             const termnum = el[0][0].termnum ? Number(el[0][0].termnum) : 1
        //             if (termnum%2) {
        //                 stack.push([])
        //             } else {
        //                 stack.unshift([])
        //             }
        //         }
        //     });
        return stack;
    }

    const renderTitles = (bigTitle, smallTitle) => (
        <View style={[pdfStyles.center, pdfStyles.mb10]}>
            {bigTitle && <Text style={[pdfStyles.subTitle]}>{bigTitle}</Text>}
            {smallTitle && <Text style={pdfStyles.subSubTitle}>{smallTitle}</Text>}
        </View>
    );

    const renderSubTitles = (bigTitle, smallTitle) => (
        <View style={pdfStyles.center}>
            {bigTitle && <Text style={pdfStyles.bold}>{bigTitle}</Text>}
            {smallTitle && <Text style={[pdfStyles.smaller, pdfStyles.bold]}>{smallTitle}</Text>}
        </View>
    );

    // const dataFieldsResolver = data => data.map(el => ({ name: el.name, type: el.participation, result: el.results }))

    const hugeTableData = useMemo(() => { }
        // resolveBigTableData(gradebook), [gradebook]
    );


    // const forTable1 = tableData || [{ name: '', participation: '', results: '' }]

    const forTable13 = tableData?.IndividPlanTable

    // const stylesCheckCell = (num) => num ? [pdfStyles.bold, pdfStyles.center, pdfStyles.centerFlex, pdfStyles.break, pdfStyles.centerVerticallyNew] : pdfStyles.ml3;
    const stylesCheckCell = (num) => num ? [pdfStyles.bold, pdfStyles.center,] : pdfStyles.ml3;
    const stylesCheckNumberCell = (num) => num ? [pdfStyles.bold, pdfStyles.center, pdfStyles.centerFlex] : [pdfStyles.center];
    const stylesCheckRow = (num) => num ? [pdfStyles.tableRow2, pdfStyles.bigHeight] : [pdfStyles.tableSmallRow];

    return (
        <Document>

            <Page size="A4" style={pdfStyles.page}>
                <View>
                    {/* <img className={pdfStyles.page_header__logo} src={`${BACKEND_URL_PREFIX}/company/gou_logo`} alt='Логотип' /> */}

                </View>
                <View style={pdfStyles.center}>
                    <Text style={pdfStyles.underline}>{"Министерство обороны Российской Федерации"}</Text>
                </View>
                <View style={[pdfStyles.center, pdfStyles.mb20, pdfStyles.mt15]}>
                    <Text>{`Филиал федерального государственного казенного военного образовательного \n учреждения высшего образования "Военная академия материально-технического \n обеспечения имен и генерала армии А.В.Хрулева" в г.Пензе`}</Text>
                </View>
                <View style={[pdfStyles.center, pdfStyles.mb10]}>
                    <Text style={pdfStyles.subTitle}>{`ИНДИВИДУАЛЬНЫЙ ПЛАН \n РАБОТЫ НА 2023-2024 УЧЕБНЫЙ ГОД`}</Text>
                </View>

                {/* <FirstTable layoutData={layoutData} user={user} portfolio={group} /> */}


                <View style={[pdfStyles.mt30, pdfStyles.ml250, pdfStyles.center, pdfStyles.superSmaller]}>
                    <Text style={pdfStyles.ml10}>
                        {'Обсужден на заседании \n 4 кафедра (средств ближнего боя) \n кафедры \n «__» _____________20___г. \n Протокол №'}
                    </Text>
                </View>
                {/* <View style={pdfStyles.mt50}>
                    <Text style={pdfStyles.ml10}>
                        {'Личная подпись обучаещегося ________________'}
                    </Text>
                </View> */}
                <View style={[pdfStyles.tableCol50, pdfStyles.center, pdfStyles.ml100, pdfStyles.mt350]}>
                    <Text>
                        {`г.Пенза`}
                    </Text>
                    <View style={[pdfStyles.underlineWork, pdfStyles.tableCol35, pdfStyles.ml80]} />

                </View>
                <Text style={[pdfStyles.tableCol50, pdfStyles.titleFirstWork, pdfStyles.center, pdfStyles.ml100]}>
                    {`(название города)`}
                </Text>

            </Page>
            <Page size="A4" style={pdfStyles.page}>
                <View style={pdfStyles.center}>
                    <Text style={pdfStyles.underline}>{"I. ЗАДАЧИ НА УЧЕБНЫЙ ГОД"}</Text>
                </View>

                {/*  ТАБЛИЦА */}
                <View style={[pdfStyles.table]}>
                    {
                        // [headers, ...forTable].map((item, index) => (
                        forTable13 && forTable13.map((item, index) => (
                            <View style={stylesCheckRow(item?.number)}>
                                <View style={[pdfStyles.tableCol5, pdfStyles.tableCol]}>
                                    <Text style={stylesCheckNumberCell(item?.number)}>
                                        {item?.number ? item.number : index + '.'}
                                    </Text>
                                </View>
                                <View style={pdfStyles.tableCol60}>
                                    <View style={pdfStyles.tableCol}>
                                        {/* ТАБЛИЦА ИСПОЛЬЗУЕТСЯ В ПРАКТИКАХ(СЕМЕСТР)-НАУЧ-ИССЛ ДЕЯТ-ЛИЧНЫЕ ДОСТ-Я(ДАТА) //TODO  потом дату еще вкарячить надо */}
                                        <Text style={stylesCheckCell(item?.number)}>{item.semester ? `${item.name}, ${item.semester}` : item.name}</Text>
                                    </View>

                                </View>
                                <View style={pdfStyles.tableCol20}>
                                    <View style={pdfStyles.tableCol}>
                                        <Text style={stylesCheckCell(item?.number)}>{item.type !== null && item.type}</Text>
                                    </View>
                                </View>

                                <View style={[pdfStyles.tableCol20, pdfStyles.center]}>
                                    <View style={pdfStyles.tableCol}>
                                        <Text style={stylesCheckCell(item?.number)}>{uppercaseGrades ? item.result?.toUpperCase('')?.split().map(item => item) : item.result?.split('').map(item => item)}</Text>
                                    </View>
                                </View>

                            </View>
                        ))
                    }
                </View>
                {/*  ТАБЛИЦА УЧЕБНЫЙ ГОД*/}

                <View style={[pdfStyles.center, pdfStyles.mt30]}>
                    <Text style={pdfStyles.underline}>{"II. ГОДОВОЙ БЮДЖЕТ СЛУЖЕБНОГО (РАБОЧЕГО) ВРЕМЕНИ"}</Text>
                </View>
                <View style={pdfStyles.ml10}>
                    <Text>
                        {`1. Годовой бюджет служебного (рабочего) времени – 0 часов.`}
                    </Text>
                    <Text>
                        {`2. Годовой бюджет времени на учебную, методическую, научную`}
                    </Text>
                    <Text>
                        {`деятельность и воспитательную работу – 0 часов`}
                    </Text>
                    <Text>
                        {`3. Учебная нагрузка, установленная приказом начальника вуза от № – 0 часов, в том числе на проведение контактной`}
                    </Text>
                    <Text>
                        {`работы с обучающимися – 0 часов`}
                    </Text>
                    <Text>
                        {`4. Время на профессионально-должностную подготовку и другие виды деятельности – 0 часов`}
                    </Text>
                    <Text>
                        {``}
                    </Text>
                    {/* <View style={[pdfStyles.underlineWork, pdfStyles.tableCol35, pdfStyles.ml80]} /> */}
                </View>
                <View style={[pdfStyles.ml80, pdfStyles.mt15]}>
                    <Text>
                        {`Распределение времени по семестрам и основным видам деятельности`}
                    </Text>
                </View>

                {/*  ТАБЛИЦА время по семестрам */}
                <View style={[pdfStyles.table,]}>
                    {
                        // [headers, ...forTable].map((item, index) => (
                        // forTable13 && forTable13.map((item, index) => (
                        <View style={[pdfStyles.tableRow2, pdfStyles.bigHeight, pdfStyles.bold]}>

                            <View style={[pdfStyles.tableCol5, pdfStyles.tableCol, pdfStyles.secondTableHeight, pdfStyles.center]}>
                                <Text>
                                    {`№ п\п`}
                                </Text>
                            </View>
                            <View style={[pdfStyles.tableCol37, pdfStyles.secondTableHeight,]}>
                                <View style={[pdfStyles.tableCol, pdfStyles.center]}>
                                    <Text>
                                        {`Основные виды деятельности`}
                                    </Text>
                                </View>

                            </View>

                            <View  >
                                <View style={pdfStyles.upper}>

                                    <View style={[pdfStyles.tableColSecTable,]}>
                                        <Text>{`Объем работы в часах`}</Text>
                                    </View>

                                    <View style={pdfStyles.middle}>
                                        <View style={pdfStyles.lower}>
                                            <View style={[pdfStyles.tableColSecTable]}>
                                                <Text>
                                                    {`I семестр`}
                                                </Text>
                                            </View>

                                            <View style={pdfStyles.lower2}>
                                                <View style={pdfStyles.tableColSecTable}>
                                                    <Text>
                                                        {`по плану`}
                                                    </Text>
                                                </View>
                                                <View style={pdfStyles.tableColSecTable}>
                                                    <Text>
                                                        {`выполнено`}
                                                    </Text>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={pdfStyles.lower}>
                                            <View style={[pdfStyles.tableColSecTable]}>
                                                <Text>
                                                    {`II семестр`}
                                                </Text>
                                            </View>

                                            <View style={pdfStyles.lower2}>
                                                <View style={pdfStyles.tableColSecTable}>
                                                    <Text>
                                                        {`по плану`}
                                                    </Text>
                                                </View>
                                                <View style={pdfStyles.tableColSecTable}>
                                                    <Text>
                                                        {`выполнено`}
                                                    </Text>
                                                </View>
                                            </View>
                                        </View>
                                        <View style={pdfStyles.lower}>
                                            <View style={[pdfStyles.tableColSecTable,]}>
                                                <Text>
                                                    {`Учебный год`}
                                                </Text>
                                            </View>

                                            <View style={pdfStyles.lower2}>
                                                <View style={pdfStyles.tableColSecTable}>
                                                    <Text>
                                                        {`по плану`}
                                                    </Text>
                                                </View>
                                                <View style={pdfStyles.tableColSecTable}>
                                                    <Text>
                                                        {`выполнено`}
                                                    </Text>
                                                </View>
                                            </View>
                                        </View>

                                    </View>
                                </View>
                            </View>
                        </View>
                        // ))
                    }
                </View>
                {/*  ТАБЛИЦА */}
            </Page>



        </Document>
    );
};

IndividualWorkPlanPrintPdf.propTypes = {
    layoutData: PropTypes.object,
    user: PropTypes.object,
};

export default IndividualWorkPlanPrintPdf;